import React from 'react'

const SearchBar = ({
  // {/* https://mui.com/material-ui/react-autocomplete/ */}
  handleSubmit,
  value,
  onChange,
  isLoading
}) => {
  return (
    <form onSubmit={handleSubmit} >
      <input 
        disabled={isLoading}
        onChange={onChange} 
        value={value} 
        className='form-control' 
        placeholder='Search Bicycles'
      />

      <input
        disabled={isLoading || !value}
        className='btn-search'
        value='Search'
        type='submit'
      />
    </form>
  )
}

export default SearchBar;